export const Officers = [
    {
        id: 1,
        name: "Dennise Alvarado",
        position: "President",
        major: "Computer Science",
        linkedin: "https://www.linkedin.com/in/denissealvarado/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284771/officers/Denisse_y2ikne.jpg"
    },
    {
        id: 2,
        name: "German Juarez",
        position: "Vice President",
        major: "Computer Science",
        linkedin: "https://www.linkedin.com/in/german-juarez-724a0a233/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284771/officers/Germ_gm95o2.jpg"
    },
    {
        id: 3,
        name: "Christian Flores",
        position: "Treasurer",
        major: "Computer Science",
        linkedin: "https://www.linkedin.com/in/christianeduardoflores/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284770/officers/Christian_pjbk6j.jpg"
    },
    {
        id: 4,
        name: "Lesly Rojas",
        position: "Secretary",
        major: "Electrical and Computer Engineering",
        linkedin: "https://www.linkedin.com/in/leslyrojascaloca/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284774/officers/Lesly_ymccxl.jpg"
    },
    {
        id: 5,
        name: "Omar Escobedo",
        position: "Outreach",
        major: "Civil Engineering",
        linkedin: "https://www.linkedin.com/in/omar-escobedo-729b65233/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284775/officers/Omar_kyh82k.jpg"
    },
    {
        id: 6,
        name: "Jorge Gonzalez",
        position: "Recruitment Chair",
        major: "Electrical and Computer Engineering",
        linkedin: "",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284772/officers/Jorge_yreahr.jpg"
    },
    {
        id: 7,
        name: "Baltazar Flug",
        position: "Social Media Chair",
        major: "Chemical Engineering",
        linkedin: "https://www.linkedin.com/in/baltazar-flug-6086b0230/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284773/officers/Keegan_ojrctk.jpg"
    },
    {
        id: 8,
        name: "Andrea Fernando Campos",
        position: "Fundraising Chair",
        major: "Mechanical Engineering",
        linkedin: "https://www.linkedin.com/in/andrea-fernando-campos/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284769/officers/Andrea_rqnot8.jpg"
    },
    {
        id: 9,
        name: "Ruby Canchola Ascencio",
        position: "Executive Board Member",
        major: "Construction Engineering and Management",
        linkedin: "https://www.linkedin.com/in/ruby-canchola-ascencio/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284898/officers/Ruby_o9bwhq.jpg"
    },
    {
        id: 10,
        name: "America Pacheco",
        position: "SHPEtina Coordinator",
        major: "Computer Science",
        linkedin: "https://www.linkedin.com/in/america-x-pacheco/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1697509854/officers/meri_snsrjj.png"
    },
    {
        id: 11,
        name: "Eric Ruiz",
        position: "Graduate Chair",
        major: "Computer Science",
        linkedin: "",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284771/officers/Eric_mcanmz.jpg"
    },
    {
        id: 12,
        name: "Alejandro Morales Cernas",
        position: "Ecampus Liaison",
        major: "Computer Science",
        linkedin: "https://www.linkedin.com/in/alejandro-morales-cernas/",
        portrait: "https://res.cloudinary.com/dy3nrj03h/image/upload/q_auto:good/v1696284768/officers/AliG_fcvoav.png"
    }
]